<template>
    <div class="col-md-12 col-sm-12 px-1">
        <div class="card mb-2">
            <div class="card-header">Direct Link</div>

            <div class="card-body permalink">
                <div class="permalink-wrapper text-center" :class="{'success': copied, 'failed': failed}" @click="clipboardCopy">
                    <span ref="link" class="link">{{ url }}</span>
                    <span class="message"><template v-if="message">{{ message }}</template></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: { default: false, },
        id: { default: false, },
    },
    data() {
        return {
            copied: false,
            failed: false,
            message: null,
        }
    },
    computed: {
        url() {
            return `${window.location.origin}/${this.type}/${this.id}`;
        }
    },
    methods: {
        clipboardCopy() {
            clipCopy(this.url)
            .then(() => {
                this.message = 'Link Copied';
                this.copied = true;

                setTimeout(() => {
                    this.copied = false;
                    setTimeout(() => {
                        this.message = null;
                    }, 500);
                }, 2 * 1000);
            })
            .catch((err) => {
                this.message = 'Link Copy Failed';
                this.failed = true;

                setTimeout(() => {
                    this.failed = false;
                    setTimeout(() => {
                        this.message = null;
                    }, 500);
                }, 2 * 1000);
            });
        },
    },
    mounted() {},
}
</script>